module.exports = __webpack_public_path__ + "img/icon-speed-8.d3a18121.svg";